import React, { useEffect, useState,forwardRef } from "react";
import DraggableImage from "./DraggableImage";
import { Stage, Layer } from "react-konva";
import DraggableText from "./DraggableTextBox";

export default forwardRef(({ selectedBanner,selectShape,selectedAssets,selectedId,changeAsset,text,changeEntireText },ref) => {
  const checkDeselect = (e) => {
    const clickedOnEmpty = e.target === e.target.getStage();
    if (clickedOnEmpty) {
      selectShape(null);
    }
  };
  return (
    <>
      <div
        className="banner-picture"
      >
        <div 
          style={{
            backgroundImage: `url(${selectedBanner})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            width: "97%",
            maxHeight:"400px",
            borderRadius:"25px"
          }}
          ref={ref}
          id ="background"
        >
                  <Stage
                      width={window.innerWidth}
                      height={window.innerHeight}
                      onMouseDown={checkDeselect}
                      onTouchStart={checkDeselect}
                  >
                      <Layer>
                        {Object.keys(selectedAssets).map((key) => {
                          return (
                            <DraggableImage
                              key={key}
                              shapeProps={selectedAssets[key]}
                              isSelected={selectedAssets[key].id === selectedId}
                              onSelect={() => {
                                selectShape(selectedAssets[key].id);
                              }}
                              onChange={(newAttrs) => {
                                changeAsset(key, {
                                  ...selectedAssets[key],
                                  ...newAttrs,
                                });
                              }}
                              link={selectedAssets[key].url}
                            />
                          );
                        })}

                        {Object.keys(text).map((key) => {
                          return text[key].text ? (
                            <DraggableText
                              key={key}
                              shapeProps={text[key]}
                              isSelected={text[key].id === selectedId}
                              onSelect={() => {
                                selectShape(text[key].id);
                              }}
                              onChange={(newAttrs) => {
                                changeEntireText(key, {
                                  ...text[key],
                                  ...newAttrs,
                                });
                              }}
                              text={text[key].text}
                            />
                          ) : (
                            <></>
                          );
                        })
                        }
                          
                      </Layer>
                    </Stage>
                    <div id = "profile-pic-bubble" className="profile-pic-bubble">
          <span>Profile Picture area</span>
        </div>           
        </div>
      </div>
    </>
  );
})
